export const levelOptions = ["-", "default", "major", "minor", "status", "flow", "off"];

export const moduleGroups = {
  "-": ["-"],
  test: ["-", "all"],
  fc: [
    "-",
    "all",
    "ipc",
    "netlink",
    "oct_ipc",
    "server",
    "main",
    "resolve",
    "db",
    "flow_mgr",
    "stats",
    "pf_key",
    "lib_fe_core",
    "hlo",
    "dns",
    "cp_filter",
    "platform",
    "ap_lib",
    "fe_ipc",
    "plat_fe_ipc",
    "pmtu",
  ],

  fe: [
    "-",
    "all",
    "ipc",
    "oct",
    "plat",
    "ril2",
    "umts",
    "l1dldata",
    "l1apimsg",
    "fib",
    "resolve",
    "nat",
    "flow_mgr",
    "gtp",
    "rtp",
    "init",
    "stats",
    "ipsec",
    "fsw",
    "replicate",
    "li",
    "dns",
    "udp_tunnel",
    "fe_ipc",
    "diag",
    "ptpd",
    "tunnel",
    "svc_chain",
    "procedures",
    "counter",
    "pmtu",
  ],

  db_client: [
    "-",
    "all",
    "alloc_client_ap",
    "free_client_ap",
    "find_client_ap",
    "print_client_ap",
    "mygetaprow",
    "mygetapcomplete",
    "main",
    "print_client_ip",
    "trace_result_string",
    "print_ap_list",
    "get_all_aps",
    "get_ap",
    "update_ap",
  ],

  ipc: ["-", "all", "default", "conn", "add", "delete", "keepalive", "memory"],

  cd: ["-", "all", "svc"],

  nb: ["-", "all", "lib", "scdb"],

  pm: ["-", "all", "process_group", "main", "process", "client_lib", "wdog"],

  ad: ["-", "all", "lib", "main", "dhcp", "arp", "config"],

  af: ["-", "all", "internal", "remote", "fd", "wdog"],

  pg: ["-", "all"],

  nem: ["-", "all", "lib", "svc", "cfg", "aaa", "stats", "cache", "ipc", "confd", "tr", "tr_lib"],

  sc: ["-", "all"],

  si: ["-", "all", "main"],

  dbg: ["-", "all", "service", "mgr", "badentry"],

  ulx: ["-", "all", "init", "start", "stop"],

  zz_ap_svc: ["-", "all", "svc"],

  zz_zz_svc: ["-", "all", "svc"],

  hsuser: ["-", "all"],

  pico: ["-", "all", "lib", "mod", "mgr", "dsp", "trans", "dma"],

  umts_procif: ["-", "all", "init", "ul", "dl", "int", "pkt", "mii"],

  sysmgr: ["-", "all", "client_lib", "mgr_pkg", "mgr", "confd", "config", "node", "node_state", "radio", "dbi", "ds", "fftp"],

  sm: ["-", "all", "main", "lib"],

  nc: ["-", "all", "main", "lib", "config", "logical", "mac", "physical", "vm", "family", "address", "inpath"],

  aaa: ["-", "all", "main", "lib", "config"],

  cm: ["-", "all", "basic", "db", "stats"],

  uem: ["-", "all", "basic", "db", "stats", "ho", "hoverif", "rrc", "nas", "feipc", "scaling"],

  ril2: ["-", "all", "basic"],

  cnm: ["-", "all", "cnsim_basic", "cnctrlmod_basic", "nbap_basic", "cnctrlmod_stats", "ranap"],

  ca: ["-", "all", "basic"],

  rfmgr: ["-", "all", "cian", "nmc", "uemeas", "sib_disp"],

  lterfm: ["-", "all", "nmc", "tx_pwr", "sib_disp"],

  ulte_son: ["-", "all", "nm_controller", "nm_cell", "wifi_scan", "lteu_scan", "mu_meas", "tables", "chs", "csat"],

  umtsdb: ["-", "all", "basic"],

  ap_pico: ["-", "all", "basic"],

  ap_ail: ["-", "all", "basic"],

  netmon_l1drv: ["-", "all", "basic"],

  umts_ue: ["-", "all", "l1drv"],

  ap_umts: [
    "-",
    "all",
    "l1drv_basic",
    "l1drv_cp",
    "l1drv_fp",
    "l1drv_fp_hsfc",
    "l1drv_meas",
    "l1drv_stats",
    "rtwp",
    "prach",
    "txcp",
    "rl_sir",
    "rl_txcp",
    "fp_cs",
  ],

  umts_gen: ["-", "all", "picor_basic", "cvasn_basic", "l1api_basic"],

  iustack: ["-", "all", "basic"],

  dbm: ["-", "all", "main", "pg_admin", "dblib", "client", "connmgr", "subth", "submgr", "util", "cfg", "logging", "gc", "br"],

  zz_act: ["-", "all", "svc"],

  nodemgr: [
    "-",
    "all",
    "dsp",
    "arm",
    "arm_stats",
    "node_mgr",
    "ap_mgr",
    "pico_mgr",
    "radio_mgr",
    "led_mgr",
    "usb_mgr",
    "stats_mon",
    "lib_radio",
    "gnss_mgr",
    "avs_svc",
    "pps_svc",
  ],

  condmgr: ["-", "all", "cond_agent", "cond_mgr", "dbi", "mo", "mo_ac", "mo_ap", "mo_radio", "mo_cell", "state_trans"],

  mi: ["-", "all", "basic"],

  armmon: ["-", "all", "daemon", "console"],

  timers: ["-", "all", "timers"],

  reboot: ["-", "all", "main", "ac", "ap"],

  ipsec: ["-", "all", "conf", "stats", "ssmgmt", "lib"],

  ntp: ["-", "all", "ntp", "svc", "cfg"],

  statsmgr: ["-", "all", "basic"],

  cfmgr: ["-", "all", "main", "lib", "globals", "timer", "client", "work_queue"],

  ptpd: ["-", "all", "svc", "dbi", "proto", "trans", "ptpd", "alg", "alarm", "bti", "base", "test", "ptpv2"],

  apd: ["-", "all", "main", "sub", "cellcfg"],

  envd: ["-", "all", "main", "ac", "ap", "alert", "lib"],

  pd: ["-", "all", "daemon", "lib", "config", "stats", "sessions"],

  bu: ["-", "all", "lib"],

  fm: ["-", "all", "lib"],

  uploadmgr: ["-", "all", "dbi", "main", "daemon", "client_lib", "transfer_thread"],

  mcd: ["-", "all", "main", "lib", "bridge", "multicast", "policer", "policy", "qos", "route", "stats", "trunk", "tunnel", "vlan"],

  cdfd: ["-", "all", "main", "lib"],

  trcd: ["-", "all", "main", "connreq", "session", "fault", "config", "nb", "rpc", "dl", "gs", "dns", "lib"],

  ev: ["-", "all", "lib"],

  cvma: ["-", "all", "lib"],

  tlv: ["-", "all", "lib"],

  drivers: ["-", "all", "scw_jiffies"],

  dm: ["-", "all", "fetch_api", "schema", "set_api"],

  showeng: ["-", "all", "main", "cmd"],

  dbmod: ["-", "all", "main"],

  adminmgr: ["-", "all", "main", "audit", "bridge", "db", "ssh", "stats", "sys", "lci", "actpt", "lib"],

  smf: [
    "-",
    "all",
    "client_library",
    "send_api",
    "main",
    "mo",
    "evt_mgr",
    "cond_mgr",
    "fault_mgr",
    "state_mgr",
    "alarm_mgr",
    "mgmt",
    "trap",
    "evt_send",
    "send_api_partial",
    "tr_notifier",
    "fmes",
  ],

  snmp: ["-", "all", "snmp", "svc", "cfg", "traplib"],

  certmgr: ["-", "all", "cfg", "lib", "cmp_cfg", "cmp_lib"],

  certlib: ["-", "all", "lib"],

  fftp: ["-", "all", "client_lib"],

  li: ["-", "all", "main", "lib"],

  showevt: ["-", "all", "main"],

  repgen: ["-", "all", "main", "config"],

  lterepgen: ["-", "all", "main", "config"],

  webserv: ["-", "all", "main", "svc", "cfg"],

  wdt: ["-", "all", "main"],

  fetcheng: ["-", "all", "main"],

  dns_lib: ["-", "all", "lib"],

  str2nem: ["-", "all", "main"],

  actionptd: ["-", "all", "main", "ping", "cellcfg", "rnrep", "lci", "tlvwrite", "diags", "log", "setclock", "install", "nslookup"],

  diag: ["-", "all", "svc", "rn_link_test"],

  ltecm: ["-", "all", "basic", "enbap", "db", "stats", "cvasn", "pwsmgr"],

  lte_gen: ["-", "all", "cvasn", "l1api", "enbap"],

  lteca: ["-", "all", "basic", "enbap"],

  epcm: ["-", "all", "basic", "stats", "db", "s1ap"],

  lteuem: ["-", "all", "basic", "sho", "homgr", "enbap", "db", "stats", "cvasn", "ffrmgr"],

  wlanctrl: ["-", "all", "main", "svc", "cfg", "wlanmgr"],

  dbg_rly: ["-", "all", "main"],

  qif: ["-", "all", "lib", "zebra"],

  rtmgr: ["-", "all", "lib", "main", "config"],

  bgpc: ["-", "all", "main", "config"],

  ual: ["-", "all", "main", "lib"],

  sendevt: ["-", "all", "main"],

  hw_utils: ["-", "all", "main", "ac", "ap"],

  diag_util: ["-", "all", "main", "ac", "ap"],

  scw_fe_lib: ["-", "all", "cpuh", "cpul", "common"],

  lte_l2: [
    "-",
    "all",
    "basic",
    "execution_legs",
    "ue_inactivity",
    "paging",
    "cpu",
    "thread",
    "smp",
    "cpu_cc0",
    "cpu_cc1",
    "log_gate_cc0",
    "log_gate_cc1",
    "flow_control",
  ],

  lte_l2_ca: ["-", "all", "pcc_scc_intf", "basic", "pcc", "scc"],

  lte_l1: ["-", "all", "basic", "dsp", "mac", "pucch_ind", "rach_ind", "pusch_ind", "cqi_ind", "eperview", "cpu", "cpu_cc0", "cpu_cc1"],

  lte_mac_stats: ["-", "all", "basic", "dl", "ul", "drx", "cqi", "acqi", "dl_sched", "ul_sched", "ue"],

  lte_mac_test: ["-", "all", "basic", "max_dl_buffer", "dummy_tx", "ul_force_grant", "test", "cqi", "scell_qload", "sdl", "lbt"],

  lte_mac_dl: [
    "-",
    "all",
    "basic",
    "cqi",
    "mux",
    "encoder",
    "harq",
    "dlsch",
    "qos_perf_stats",
    "scc_sync",
    "scc_mux",
    "scc_encoder",
    "scc_harq",
    "scc_dlsch",
    "pcc_dlsch",
    "la",
    "drx_ce",
  ],

  lte_mac_ul: [
    "-",
    "all",
    "basic",
    "subframe_ind",
    "crc",
    "ulsch",
    "harq",
    "sr",
    "srs",
    "rach",
    "cqi",
    "demux",
    "pwr_meas",
    "ta",
    "sync",
    "pusch_pwr_ctrl",
    "pucch_pwr_ctrl",
    "bsr_phr",
    "qos_perf_stats",
    "fss",
    "acqi",
    "initial_ulsch",
  ],

  lte_sched_dl: [
    "-",
    "all",
    "basic",
    "strategy",
    "rr",
    "qos",
    "rb_alloc",
    "cce_alloc",
    "load_mgr",
    "sync",
    "meas_gap",
    "drx",
    "olla",
    "tpc",
    "ta",
    "qos_gbr",
    "qos_non_gbr",
    "qos_token",
    "qos_tti_stats",
    "qos_tti_stats_enable",
    "pcc_ca_strategy",
    "scc_strategy",
    "scc_rb_alloc",
    "scc_cce_alloc",
    "harq",
    "scc_harq",
    "scc_sync",
    "resources",
    "la",
    "delay",
    "qos_tree",
  ],

  lte_pdcch: ["-", "all", "basic", "mib", "sib", "cce_ue_space", "cce_cmn_space", "drx", "cfi", "cce", "fail"],

  lte_sched_ul: [
    "-",
    "all",
    "basic",
    "strategy",
    "pdcch_alloc",
    "rb_alloc",
    "la",
    "harq",
    "nz_bsr",
    "validate_rb",
    "process_nack",
    "sync_state",
    "ue_status",
    "resources",
    "pucch_alloc",
    "qos",
    "qos_token",
    "queues",
    "ffr",
    "qos_gbr",
    "qos_non_gbr",
    "qos_tti_stats",
    "qos_tti_stats_enable",
    "fss",
    "acqi",
    "qos_tree",
    "ulsch_uci",
  ],

  lte_mac_sdl: ["-", "all", "csat", "lbt", "lds", "resource"],

  lte_rlc_dl: [
    "-",
    "all",
    "basic",
    "rx_sdu",
    "encode_pdu",
    "encode_pdu_seg_dfe",
    "rx_nack_list",
    "rx_ack",
    "send_delivery_ind",
    "poll_retransmit",
    "tx_opp",
    "flow_control",
    "um",
    "proc_time",
  ],

  lte_rlc_ul: [
    "-",
    "all",
    "basic",
    "status_pdu",
    "decode_header",
    "rx_pdu",
    "rx_pdu_seg",
    "deliver_sdu",
    "status_prohibit",
    "reordering",
    "um",
    "proc_time",
  ],

  lte_pdcp_dl: ["-", "all", "basic", "cipher", "flow_control", "forward", "delay"],

  lte_pdcp_ul: ["-", "all", "basic", "cipher", "forward", "delay"],

  lte_fapi: [
    "-",
    "all",
    "basic",
    "rb_alloc",
    "ulconfig_ulsch",
    "ul_cfg_req",
    "dl_cfg_req",
    "tx_req",
    "hi_dci0_req",
    "ulconfig_uci",
    "uci_ind",
    "cqi_ind",
    "rach_ind",
    "harq_ind",
    "ulsch_ind",
    "crc_ind",
    "sr_ind",
    "meas_ind",
    "lbt",
    "subframe_ind",
  ],

  lte_data_dl: ["-", "all", "basic", "rb_alloc", "tb_size", "harq_status"],

  lte_rrc_l2: ["-", "all", "basic", "mac", "rlc", "pdcp"],

  lte_mac_emtc: [
    "-",
    "all",
    "mib",
    "sib",
    "pcch",
    "rach",
    "ccch",
    "mpdcch",
    "pdsch",
    "pucch",
    "pusch",
    "sync",
    "dl_qos",
    "ul_qos",
    "encoder",
    "mux",
    "dl_la",
    "ul_la",
    "dl_harq",
    "ul_harq",
    "cqi",
    "ul_config",
    "fapi",
    "ulsch",
  ],

  lte_netmonl1drv: ["-", "all", "basic"],

  kernel: ["-", "all", "emerg", "alert", "crit", "err", "warning", "notice", "info", "debug"],

  cfwatcher: ["-", "all", "main", "lib", "globals", "timer", "client", "work_queue"],

  procgrp: ["-", "all", "procgrp", "main", "process"],

  vmmgr: ["-", "all", "main", "imageget"],

  vmd: ["-", "all", "main", "virt"],

  logproxy: ["-", "all", "tenx", "hex2", "krait", "hex1", "hex0", "hex3"],

  fsminit: ["-", "all", "main", "lib", "krait", "svc", "ap"],

  cbsdmgr: ["-", "all", "basic", "stats", "db", "sas", "json", "transport"],

  cprimgr: ["-", "all", "main", "cmaapi", "mgmt", "dbi", "port", "cell", "client", "fpga", "alarm"],

  vbbu_umts_ops: ["-", "all", "main"],

  fpga: ["-", "all", "lib"],

  mux: ["-", "all", "lib"],

  nrcellmgr: ["-", "all", "basic", "nrduap", "db", "stats", "cvasn"],

  nr_gen: ["-", "all", "cvasn", "l1api", "nrduap"],

  ngcmgr: ["-", "all", "basic", "stats", "db", "x2ap", "stack"],

  nruemgr: ["-", "all", "basic", "nrduap", "db", "stats", "cvasn"],

  nrduca: ["-", "all", "basic", "nrduap"],

  nrpdcp: ["-", "all", "basic", "distributor", "throughput", "entity", "handout", "handin", "worker", "stats"],

  nr_pdcp_dl: ["-", "all", "basic", "throughput", "cipher", "forward", "delay", "flowcontrol", "buffers", "handout", "handin", "stats"],

  nr_pdcp_ul: ["-", "all", "basic", "throughput", "cipher", "reordering", "forward", "delay", "buffers", "handout", "handin", "stats"],

  fe_nrpdcp_common: ["-", "all", "basic", "port", "pkt_container"],

  nrrfm: ["-", "all", "nmc", "tx_pwr"],

  ngrepgen: ["-", "all", "main", "config"],

  orumgr: ["-", "all", "main", "config", "lib", "lib_netconf", "lib_yang"],

  l1_svc: [
    "-",
    "all",
    "main",
    "fapi_pdsch",
    "fapi_pdcch",
    "fapi_pbch",
    "fapi_csirs",
    "fapi_pusch",
    "fapi_pucch",
    "prach_det",
    "pusch_meas",
    "pusch_dec",
    "pucch_f0",
    "pucch_f2_meas",
    "pucch_f2_dec",
    "l1_stats",
  ],

  nr_mac_dl: ["-", "all", "basic", "mux", "encoder", "harq", "dlsch", "la", "csi"],

  nr_mac_ul: ["-", "all", "basic", "crc", "ulsch", "harq", "sr", "rach", "demux", "pusch_pwr_ctrl", "pucch_pwr_ctrl", "bsr_phr", "sync"],

  nr_sched_dl: [
    "-",
    "all",
    "basic",
    "strategy",
    "rb_alloc",
    "cce_alloc",
    "harq",
    "drx",
    "bm_res",
    "beam_switch",
    "load_mgr",
    "scc_enable",
    "meas_gap",
    "paging",
  ],

  nr_pdcch: ["-", "all", "basic", "ssb", "sib", "si", "cce_ue_space", "cce_cmn_space", "paging"],

  nr_sched_ul: ["-", "all", "basic", "strategy", "pdcch_alloc", "rb_alloc", "harq", "la", "bm_res", "pucch_alloc"],

  nr_rlc_dl: [
    "-",
    "all",
    "basic",
    "flow_control",
    "rx_sdu",
    "encode_pdu",
    "um",
    "rx_ack",
    "rx_nack",
    "encode_pdu_seg",
    "tx_opp",
    "poll_retransmit",
    "retx_pdu",
  ],

  nr_rlc_ul: ["-", "all", "basic", "decode_header", "rx_pdu", "um", "status_pdu", "status_prohibit", "deliver_sdu"],

  nr_fapi: [
    "-",
    "all",
    "basic",
    "ul_cfg_req",
    "ulconfig_ulsch",
    "dl_cfg_req",
    "tx_req",
    "hi_dci0_req",
    "uci_ind",
    "rach_ind",
    "harq_ind",
    "ulsch_ind",
    "crc_ind",
    "sr_ind",
    "rf_slot_cfg",
  ],

  nr_rrc_l2: ["-", "all", "basic", "mac", "rlc", "egtpu"],

  nr_l2: [
    "-",
    "all",
    "basic",
    "execution_legs",
    "ue_inactivity",
    "paging",
    "cpu",
    "thread",
    "smp",
    "cpu_cc0",
    "cpu_cc1",
    "log_gate_cc0",
    "log_gate_cc1",
    "flow_control",
    "mac_kpi",
    "rlc_kpi",
  ],

  nr_l2_mac_stats: ["-", "all", "basic", "dl", "ul", "mcs", "cqi", "pusch", "dl_sched", "ul_sched", "rach"],

  nr_l2_rlc_stats: ["-", "all", "basic", "dl", "ul"],

  nr_egtpu: ["-", "all", "basic", "ul_parsing"],

  nr_mac_test: ["-", "all", "test"],

  all: ["-", "all"],
} as { [key: string]: string[] };
